import { render, staticRenderFns } from "./PreGame.vue?vue&type=template&id=75bda1c1&"
import script from "./PreGame.vue?vue&type=script&lang=js&"
export * from "./PreGame.vue?vue&type=script&lang=js&"
import style0 from "./PreGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bda1c1')) {
      api.createRecord('75bda1c1', component.options)
    } else {
      api.reload('75bda1c1', component.options)
    }
    module.hot.accept("./PreGame.vue?vue&type=template&id=75bda1c1&", function () {
      api.rerender('75bda1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PreGame.vue"
export default component.exports